import { httpApi } from '@app/api/http.api';
import { notificationController } from '@app/controllers/notificationController';
import { useTranslation } from 'react-i18next';

// const { t } = useTranslation();

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
  // totalPage?: number;
}
export const toTimestamp = (strDate: string): number => {
  const datum = Date.parse(strDate);
  return datum;
};

//===========================================================================

export const getIssue = (req: any): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/' + (req.type == 'safety' ? req.type + '/' + req.id : req.type + '/detail/' + req.id))
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
      // notificationController.error( { message: error.message});
    });

export const getListIssue = (req: any, pagination: Pagination): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0' + '/issue/search', {
      params: { limit: pagination.pageSize, page: pagination.current, ...req },
    })
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
    });

export const createIssue = (req: any): Promise<any> =>
  httpApi
    .post<any>('/cbm/api/gemba/v0/' + req.type, { ...req.data })
    .then((response) => {
      console.log(' http res ', response);

      return response;
    })
    .catch(function (error) {
      console.log('error ', error);

      // notificationController.error({ message: error.message});
    });

export const editIssue = (req: any): Promise<any> =>
  httpApi
    .put<any>('/cbm/api/gemba/v0/' + req.type + '/' + req.data.id, { ...req.data })
    .then((response) => {
      // if(response && response.data){
      //   return response.data;
      // }
      return response;
    })
    .catch(function (error) {
      console.log('editIssue error ', error);
    });

export const deleteIssue = (req: any): Promise<any> =>
  httpApi.delete<any>('/cbm/api/gemba/v0/' + req.group + '/delete', { data: [req.id] }).then((response) => {
    return response;
  });

export const exportIssue = (req: any): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/issue/export', { responseType: 'blob', params: { ...req } })
    .then(({ data }) => data);

export const getStatistic = (req: any, pagination: Pagination): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/statistic' + (req.processName ? '/process' : ''), { params: { ...req } })
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message); // this is the main part. Use the response property from the error object

      // notificationController.error( { message: error.message});
    });

export const getQualityStatistic = (req: any): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/statistic/quality', { params: { ...req } })
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
      // notificationController.error( { message: error.message});
    });

export const getProductivityStatistic = (req: any): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/statistic/productivity', { params: { ...req } })
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
      // notificationController.error( { message: error.message});
    });

export const getAuditOperatorList = (): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/audit-operator')
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
    });

export interface AuditOperatorPayload {
  name: string;
}

export const createAuditOperator = (payload: AuditOperatorPayload): Promise<any> =>
  httpApi.post<any>('/cbm/api/gemba/v0/audit-operator', payload).then(({ data }) => data);

export const updateAuditOperator = (id: string, payload: AuditOperatorPayload): Promise<any> =>
  httpApi.put<any>(`/cbm/api/gemba/v0/audit-operator/${id}`, payload).then(({ data }) => data);

export const deleteAuditOperator = (id: string): Promise<any> =>
  httpApi.delete<any>(`/cbm/api/gemba/v0/audit-operator/${id}`).then(({ data }) => data);

export const getQualityAuditOptions = (): Promise<any> =>
  httpApi
    .get<any>('/cbm/api/gemba/v0/quality/audit-options')
    .then(({ data }) => data)
    .catch(function (error) {
      console.log(error.message);
    });
